import Partner from './partner.js';

export enum GlobalApplicantType {
  Applicant = 'Applicant',
}

export enum ApplicantTypeRole {
  FirstParty = 'FIRST_PARTY',
  ThirdParty = 'THIRD_PARTY',
}

export interface ApplicantType {
  id: string;
  name: string;
  partnerId?: string;
  partner?: Partner;
  role: ApplicantTypeRole;
}
